import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Space } from 'antd';
import { StatePill } from '@common/components';
import ExtensionDetailItemStateStyledValue from './extension-detail-item-state-styled-value';

const { Text } = Typography;

function Previously({ originalValue }) {
  return (
    <>
      <br />
      <span className="previously">
        (previously <span className="text-capitalize">{originalValue}</span>)
      </span>
    </>
  );
}

function OverridedValue({ value, overridedValue }) {
  return (
    <Space>
      <Text type="secondary" delete>
        {overridedValue}
      </Text>
      <StatePill color="grass">{value}</StatePill>
    </Space>
  );
}

export default function ExtensionDetailItemValue({
  state,
  value,
  originalValue,
  oldValue,
}) {
  return (
    <>
      {oldValue && oldValue !== value ? (
        <OverridedValue value={value} overridedValue={oldValue} />
      ) : (
        <ExtensionDetailItemStateStyledValue value={value} state={state} />
      )}
      {(originalValue === 0 || !!originalValue) && (
        <Previously originalValue={originalValue} />
      )}
    </>
  );
}

const valueType = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.number,
  PropTypes.node,
]);

ExtensionDetailItemValue.propTypes = {
  value: valueType.isRequired,
  state: PropTypes.string,
  originalValue: valueType,
  oldValue: valueType,
};

OverridedValue.propTypes = {
  value: valueType,
  overridedValue: valueType,
};

Previously.propTypes = {
  originalValue: valueType,
};
